import gql from 'graphql-tag';

// This is used in GlobalNav
export const getMessageNotificationForAssociate = gql`
  query getMessageNotificationForAssociate($associateId: String) {
    getMessageNotificationForAssociate(associateId: $associateId) {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used in GlobalNav
export const getNotificationCountForAssociate = gql`
  query getNotificationCountForAssociate($associateId: String) {
    getNotificationCountForAssociate(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in notifications
export const getEventsForAssociate = gql`
  query getEventsForAssociate($associateId: String) {
    getEventsForAssociate(associateId: $associateId) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
      message
      customerId
    }
  }
`;

// This is used in notifications with pagination
export const getEventsForAssociateWithPagination = gql`
  query getEventsForAssociateWithPagination($associateId: String, $limit: Int, $nextToken: String, $type: [String!]) {
    getEventsForAssociateWithPagination(associateId: $associateId, limit: $limit, nextToken: $nextToken, type: $type) {
      nextToken
      items {
        eventId
        associateId
        event_status
        type
        description
        timestamp
        customerName
        message
        customerId
      }
    }
  }
`;

// This is used on HomePage and Conversations Page
export const getAssociateStatus = gql`
  query getAssociateStatus($associatePin: String!) {
    getAssociateStatus(associatePin: $associatePin) {
      associateStatus
    }
  }
`;

//This is used on Client Central Page - Online Bag Tab
export const getOnlineBagNotificationForAssociate = gql`
  query getOnlineBagNotificationForAssociate($associatePin: String) {
    getOnlineBagNotificationForAssociate(associatePin: $associatePin) {
      associatePin
      notificationCount
    }
  }
`;
